// extracted by mini-css-extract-plugin
export default {"Projects":"ProjectsDark_Projects__FXV1v"};